<template>
  <v-container grid-list-xs fluid>
    <v-tabs
      grow
      v-model="tab"
      class="shadow"
      slider-color="primary"
      color=" grey lighten-3"
      active-class="primary white--text"
    >
      <v-tab ripple class="font-weight-bold" href="#part1">{{
        $t("part1")
      }}</v-tab>
      <v-tab ripple class="font-weight-bold" href="#part2">{{
        $t("part2")
      }}</v-tab>
      <v-tab ripple class="font-weight-bold" href="#part3">{{
        $t("part3")
      }}</v-tab>
      <v-tab ripple class="font-weight-bold" href="#part4">{{
        $t("part4")
      }}</v-tab>
      <v-tab ripple class="font-weight-bold" href="#part5">{{
        $t("part5")
      }}</v-tab>
      <v-tab ripple class="font-weight-bold" href="#scoreCard">{{
        $t("score_card")
      }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="shadow">
      <v-tab-item value="part1">
        <assessment
          :cso="CSO"
          section="1"
          lessThan="3"
          @next="tab = 'part2'"
          :questions="questions"
          :assessment="assessment"
          @answerChanged="getScoreCards"
          :score_cards="score_cards.filter(x => x.section == 1)"
        />
      </v-tab-item>

      <v-tab-item value="part2">
        <assessment
          :cso="CSO"
          section="2"
          lessThan="3"
          @back="tab = 'part1'"
          @next="tab = 'part3'"
          :questions="questions"
          :assessment="assessment"
          @answerChanged="getScoreCards"
          :score_cards="score_cards.filter(x => x.section == 2)"
        />
      </v-tab-item>

      <v-tab-item value="part3">
        <assessment
          :cso="CSO"
          section="3"
          lessThan="3"
          @back="tab = 'part2'"
          @next="tab = 'part4'"
          :questions="questions"
          :assessment="assessment"
          @answerChanged="getScoreCards"
          :score_cards="score_cards.filter(x => x.section == 3)"
        />
      </v-tab-item>

      <v-tab-item value="part4">
        <assessment
          :cso="CSO"
          section="4"
          lessThan="3"
          @back="tab = 'part3'"
          @next="tab = 'part5'"
          :questions="questions"
          :assessment="assessment"
          @answerChanged="getScoreCards"
          :score_cards="score_cards.filter(x => x.section == 4)"
        />
      </v-tab-item>

      <v-tab-item value="part5">
        <assessment
          :cso="CSO"
          section="5"
          lessThan="3"
          @back="tab = 'part4'"
          @next="tab = 'scoreCard'"
          :questions="questions"
          :assessment="assessment"
          @answerChanged="getScoreCards"
          :score_cards="score_cards.filter(x => x.section == 5)"
        />
      </v-tab-item>

      <v-tab-item value="scoreCard">
        <score-card
          :cso="CSO"
          :total="true"
          ref="score_card"
          @submited="getCSO"
          v-model="assessment"
          :score_cards="score_cards"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
export default {
  name: "reAssessment",
  props: ["assessment_id", "assessment"],
  components: {
    scoreCard: () => import("./scoreCard"),
    assessment: () => import("./assessment")
  },

  data: () => ({
    CSO: {},
    answers: {},
    tab: "part1",
    questions: [],
    score_cards: []
  }),

  methods: {
    async getScoreCards() {
      this.axios
        .get(`results?assessment_id=${this.assessment.id}`)
        .then(res => {
          this.score_cards = res.data.data;
        });
    },

    async getCSO() {
      let CSO_id = this.$route.params.id;
      await this.axios.get(`/CSOs/${CSO_id}`).then(res => {
        this.CSO = res.data.data;
      });
    },

    async initData() {
      await this.getCSO();

      await this.axios.get("questions").then(res => {
        this.questions = res.data.data;
      });

      await this.axios
        .get(`answers?assessment_id=${this.assessment.id}`)
        .then(res => {
          this.answers = res.data;
        });

      this.questions = this.questions.map(item => ({
        ...item,
        answer: this.answers[item.id] ? this.answers[item.id].answer : "N/A",
        old_answer: this.answers[item.id]
          ? this.answers[item.id].old_answer
          : "N/A"
      }));

      this.getScoreCards();
    }
  }
};
</script>
